import { render, staticRenderFns } from "./programme.vue?vue&type=template&id=70d45e90"
import script from "./programme.vue?vue&type=script&lang=js"
export * from "./programme.vue?vue&type=script&lang=js"
import style0 from "./programme.vue?vue&type=style&index=0&id=70d45e90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports